import React, { useMemo, useState } from 'react';
import api from '../utils/api';

const serviceSuggestions = [
  'Тос, шингэн солих',
  'Компьютер оношилгоо',
  'Явах анги шалгах',
  'Тормосны үйлчилгээ',
  'Хөдөлгүүр шалгах',
  'Цахилгааны оношилгоо'
];

const ServiceBookingModal = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({
    phone: '',
    carModel: '',
    plateNumber: '',
    serviceType: '',
    preferredDate: '',
    note: ''
  });
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const normalizedDate = useMemo(() => {
    const parsed = new Date(form.preferredDate);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }, [form.preferredDate]);

  const validateStepOne = () => {
    if (!form.phone.trim() || !form.carModel.trim() || !form.plateNumber.trim()) {
      return 'Утас, машины загвар, улсын дугаарыг бүрэн оруулна уу';
    }

    if (form.phone.replace(/\D/g, '').length < 8) {
      return 'Утасны дугаар багадаа 8 оронтой байна';
    }

    return '';
  };

  const validateStepTwo = () => {
    if (!form.serviceType.trim() || !form.preferredDate.trim()) {
      return 'Үйлчилгээ болон хүссэн огноогоо сонгоно уу';
    }

    if (!normalizedDate) {
      return 'Огноо буруу байна';
    }

    if (normalizedDate.getTime() < Date.now() - 60000) {
      return 'Өнгөрсөн цаг дээр захиалга үүсгэж болохгүй';
    }

    return '';
  };

  const goNext = () => {
    const validationError = validateStepOne();
    setError(validationError);
    if (!validationError) {
      setStep(2);
    }
  };

  const submit = async (event) => {
    event.preventDefault();
    const validationError = validateStepTwo();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/service-bookings', form);
      if (typeof onSuccess === 'function') {
        onSuccess(response.data?.booking);
      }
      onClose();
    } catch (requestError) {
      const responseData = requestError.response?.data;
      const validationMessage = Array.isArray(responseData?.errors)
        ? responseData.errors.map((item) => item.message).join(', ')
        : '';
      setError(validationMessage || responseData?.message || 'Захиалга үүсгэх үед алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" style={{background:'rgba(0,0,0,0.18)'}} onClick={onClose}>
      <div className="modal" style={{maxWidth:420, background:'#fff', color:'#111'}} onClick={e => e.stopPropagation()}>
        <h3 style={{marginBottom:18, color:'#111'}}>Засвар үйлчилгээний захиалга</h3>
        <div className="booking-stepper">
          <span className={step === 1 ? 'booking-step active' : 'booking-step'} style={{color: step === 1 ? '#b45309' : '#222', background: step === 1 ? '#fef3c7' : '#f3f4f6', borderColor: step === 1 ? '#f59e0b' : '#d1d5db'}}>
            1. Машины мэдээлэл
          </span>
          <span className={step === 2 ? 'booking-step active' : 'booking-step'} style={{color: step === 2 ? '#b45309' : '#222', background: step === 2 ? '#fef3c7' : '#f3f4f6', borderColor: step === 2 ? '#f59e0b' : '#d1d5db'}}>
            2. Үйлчилгээ ба баталгаажуулалт
          </span>
        </div>
        <form className="form" onSubmit={submit}>
          {step === 1 ? (
            <>
              <input
                placeholder="Утасны дугаар"
                value={form.phone}
                onChange={(event) => setForm((prev) => ({ ...prev, phone: event.target.value }))}
                required
                style={{background:'#fff',color:'#111',border:'1.5px solid #d1d5db' }}
              />
              <input
                placeholder="Машины загвар"
                value={form.carModel}
                onChange={(event) => setForm((prev) => ({ ...prev, carModel: event.target.value }))}
                required
                style={{background:'#fff',color:'#111',border:'1.5px solid #d1d5db' }}
              />
              <input
                placeholder="Улсын дугаар"
                value={form.plateNumber}
                onChange={(event) => setForm((prev) => ({ ...prev, plateNumber: event.target.value.toUpperCase() }))}
                required
                style={{background:'#fff',color:'#111',border:'1.5px solid #d1d5db' }}
              />
            </>
          ) : (
            <>
              <input
                placeholder="Үйлчилгээний төрөл"
                value={form.serviceType}
                onChange={(event) => setForm((prev) => ({ ...prev, serviceType: event.target.value }))}
                list="service-booking-suggestions"
                required
                style={{background:'#fff',color:'#111',border:'1.5px solid #d1d5db' }}
              />
              <datalist id="service-booking-suggestions">
                {serviceSuggestions.map((item) => (
                  <option key={item} value={item} />
                ))}
              </datalist>
              <input
                type="datetime-local"
                value={form.preferredDate}
                onChange={(event) => setForm((prev) => ({ ...prev, preferredDate: event.target.value }))}
                required
                style={{background:'#fff',color:'#111',border:'1.5px solid #d1d5db' }}
              />
              <textarea
                placeholder="Нэмэлт тайлбар (заавал биш)"
                value={form.note}
                onChange={(event) => setForm((prev) => ({ ...prev, note: event.target.value }))}
                style={{background:'#fff',color:'#111',border:'1.5px solid #d1d5db' }}
              />
              <button type="submit" disabled={loading} style={{background:'#2563eb',color:'#fff',borderRadius:8,marginTop:16}}>
                {loading ? 'Илгээж байна...' : 'Баталгаажуулах'}
              </button>
            </>
          )}

          {error && <div style={{color:'#ef4444',marginTop:10}}>{error}</div>}

          {step === 1 ? (
            <button type="button" onClick={goNext}>Дараагийн алхам</button>
          ) : (
            <>
              <button type="submit" disabled={loading}>
                {loading ? 'Илгээж байна...' : 'Захиалга илгээх'}
              </button>
              <button type="button" onClick={() => { setError(''); setStep(1); }}>Өмнөх алхам</button>
            </>
          )}
          <button type="button" onClick={onClose}>Хаах</button>
        </form>
        <button onClick={onClose} style={{marginTop:12,background:'#f3f4f6',color:'#111',borderRadius:8}}>Хаах</button>
      </div>
    </div>
  );
};

export default ServiceBookingModal;
